<lib-modal
  [visible]="true"
  [title]="
    paket()
      ? ('testPlans.packageDialog.titleEdit' | translate: { name: paket()!.name })
      : ('testPlans.packageDialog.titleNew' | translate)
  "
  [contentTemplate]="inhalt"
  [showButtons]="false"
  [showClose]="false"
  (visibleChange)="beimSchliessenDurchModal($event)"
></lib-modal>

<ng-template #inhalt>
  <div class="paket-dialog" data-testid="testpaket-dialog">
    <p class="paket-dialog__untertitel">
      {{ 'testPlans.packageDialog.subtitle' | translate: { count: testfaelle().length } }}
    </p>

    @if (!paket()) {
      <mat-form-field appearance="fill" floatLabel="always" class="paket-dialog__feld tc-field--uppercase-label">
        <mat-label>{{ 'testPlans.packageDialog.name' | translate }}</mat-label>
        <input
          #nameFeld
          matInput
          required
          data-testid="paket-dialog-name"
          [value]="name()"
          [attr.maxlength]="nameMax"
          (input)="name.set($any($event.target).value)"
          (keydown.enter)="nichtAbsenden($event)"
        />
      </mat-form-field>
    }

    <div class="paket-dialog__suche">
      <mat-icon class="paket-dialog__suche-icon" aria-hidden="true">search</mat-icon>
      <input
        type="text"
        class="paket-dialog__suche-feld"
        data-testid="paket-dialog-suche"
        [value]="suche()"
        [placeholder]="'testPlans.packageDialog.search' | translate"
        [attr.aria-label]="'testPlans.packageDialog.searchLabel' | translate"
        (input)="suche.set($any($event.target).value)"
        (keydown.enter)="nichtAbsenden($event)"
      />
    </div>

    <div class="paket-dialog__tabelle">
      <div class="paket-dialog__kopf">
        <input
          type="checkbox"
          class="paket-dialog__checkbox"
          data-testid="paket-dialog-alle-freien"
          [checked]="alleFreienGewaehlt()"
          [disabled]="keineFreien()"
          [attr.aria-label]="'testPlans.packageDialog.selectAllFree' | translate"
          [title]="'testPlans.packageDialog.selectAllFree' | translate"
          (change)="alleFreienUmschalten()"
        />
        <span class="paket-dialog__spalte-id">{{ 'testPlans.packageDialog.columnId' | translate }}</span>
        <span class="paket-dialog__spalte-titel">{{ 'testPlans.packageDialog.columnTitle' | translate }}</span>
        <span class="paket-dialog__spalte-paket">{{ 'testPlans.packageDialog.columnPackage' | translate }}</span>
      </div>

      <div class="paket-dialog__liste">
        @for (zeile of zeilen(); track zeile.testfall.id) {
          <label
            class="paket-dialog__zeile"
            data-testid="paket-dialog-testfall"
            [class.paket-dialog__zeile--gewaehlt]="zeile.gewaehlt"
            [class.paket-dialog__zeile--belegt]="zeile.belegtIn !== null"
          >
            <input
              type="checkbox"
              class="paket-dialog__checkbox"
              [checked]="zeile.gewaehlt"
              [disabled]="zeile.belegtIn !== null"
              (change)="umschalten(zeile.testfall.id)"
            />
            <code class="paket-dialog__spalte-id paket-dialog__id">{{ zeile.testfall.key }}</code>
            <span class="paket-dialog__spalte-titel paket-dialog__titel">{{ zeile.testfall.title }}</span>
            <span class="paket-dialog__spalte-paket paket-dialog__paket">
              @if (zeile.belegtIn !== null) {
                {{ 'testPlans.packageDialog.inPackage' | translate: { name: zeile.belegtIn } }}
              } @else {
                —
              }
            </span>
          </label>
        } @empty {
          <p class="paket-dialog__leer" data-testid="paket-dialog-leer">
            {{
              (testfaelle().length ? 'testPlans.packageDialog.noHit' : 'testPlans.packageDialog.noTestCases')
                | translate
            }}
          </p>
        }
      </div>
    </div>

    <div class="paket-dialog__fuss">
      <span class="paket-dialog__anzahl" data-testid="paket-dialog-anzahl">
        {{ 'testPlans.packageDialog.selected' | translate: { count: wahl().size } }}
      </span>
      <button
        mat-stroked-button
        type="button"
        class="paket-dialog__knopf"
        data-testid="paket-dialog-abbrechen"
        (click)="abgebrochen.emit()"
      >
        {{ 'testPlans.packageDialog.cancel' | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="paket-dialog__knopf paket-dialog__knopf--primaer"
        data-testid="paket-dialog-uebernehmen"
        [disabled]="uebernehmenGesperrt()"
        (click)="bestaetigen()"
      >
        {{ (paket() ? 'testPlans.packageDialog.apply' : 'testPlans.packageDialog.create') | translate }}
      </button>
    </div>
  </div>
</ng-template>
